import i18next from 'app/lib/i18n/i18n';
import { useTranslation } from 'react-i18next';
import { TPaths } from 'app/lib/@types';
import en from './en.json';
import ru from './ru.json';

const pageLayoutTranslationNs = 'pageLayout';

i18next.addResourceBundle('en', pageLayoutTranslationNs, en);
i18next.addResourceBundle('ru', pageLayoutTranslationNs, ru);

declare module 'i18next' {
  interface i18nResources {
    [pageLayoutTranslationNs]: typeof en;
  }
  interface CustomTypeOptions {
    // custom namespace type if you changed it
    //defaultNS: typeof companiesPageTranslationNs;
    // custom resources type
    resources: i18nResources;
  }
}

export type TPageLayoutTranslationPaths = TPaths<typeof en> &
  TPaths<typeof ru>;

export function usePageLayoutTranslations(): (
  key: TPageLayoutTranslationPaths,
  options?: Record<string, string | number>
) => string {
  const { t } = useTranslation(pageLayoutTranslationNs);
  return t;
}
